import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { CALYPSO } from 'HubStyleTokens/colors';
import Small from 'UIComponents/elements/Small';
const TileWithLeftBorder = styled(UITile).withConfig({
  displayName: "PropertiesFormDependentSection__TileWithLeftBorder",
  componentId: "sc-1a48vzh-0"
})(["border-left:solid 5px ", ";"], CALYPSO);

function PropertiesFormDependentSection({
  children,
  property
}) {
  return /*#__PURE__*/_jsx(TileWithLeftBorder, {
    compact: true,
    className: "m-top-4 m-bottom-2",
    "data-test-id": `${property.name}-dependents`,
    children: /*#__PURE__*/_jsxs(UITileSection, {
      children: [/*#__PURE__*/_jsx(Small, {
        weight: "medium",
        children: /*#__PURE__*/_jsx(UIHelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "propertiesForm.dependentFieldsHelp",
            options: {
              label: property.label
            }
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "propertiesForm.dependentFieldsTitle"
          })
        })
      }), children]
    })
  });
}

export default PropertiesFormDependentSection;